/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PhotoMode {
}

export enum PhotoMode_Enum {
  SUBJECT_CAMERA_JPG = 0,
  SUBJECT_CAMERA_DNG = 1,
  IR_CAMERA_JPG = 2,
  SUBJECT_CAMERA_RAW = 3,
  IR_CAMERA_RJPEG = 4,
  INVALID = 5,
  UNRECOGNIZED = -1,
}

export function photoMode_EnumFromJSON(object: any): PhotoMode_Enum {
  switch (object) {
    case 0:
    case "SUBJECT_CAMERA_JPG":
      return PhotoMode_Enum.SUBJECT_CAMERA_JPG;
    case 1:
    case "SUBJECT_CAMERA_DNG":
      return PhotoMode_Enum.SUBJECT_CAMERA_DNG;
    case 2:
    case "IR_CAMERA_JPG":
      return PhotoMode_Enum.IR_CAMERA_JPG;
    case 3:
    case "SUBJECT_CAMERA_RAW":
      return PhotoMode_Enum.SUBJECT_CAMERA_RAW;
    case 4:
    case "IR_CAMERA_RJPEG":
      return PhotoMode_Enum.IR_CAMERA_RJPEG;
    case 5:
    case "INVALID":
      return PhotoMode_Enum.INVALID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoMode_Enum.UNRECOGNIZED;
  }
}

export function photoMode_EnumToJSON(object: PhotoMode_Enum): string {
  switch (object) {
    case PhotoMode_Enum.SUBJECT_CAMERA_JPG:
      return "SUBJECT_CAMERA_JPG";
    case PhotoMode_Enum.SUBJECT_CAMERA_DNG:
      return "SUBJECT_CAMERA_DNG";
    case PhotoMode_Enum.IR_CAMERA_JPG:
      return "IR_CAMERA_JPG";
    case PhotoMode_Enum.SUBJECT_CAMERA_RAW:
      return "SUBJECT_CAMERA_RAW";
    case PhotoMode_Enum.IR_CAMERA_RJPEG:
      return "IR_CAMERA_RJPEG";
    case PhotoMode_Enum.INVALID:
      return "INVALID";
    case PhotoMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePhotoMode(): PhotoMode {
  return {};
}

export const PhotoMode = {
  encode(_: PhotoMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PhotoMode {
    return {};
  },

  toJSON(_: PhotoMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoMode>, I>>(base?: I): PhotoMode {
    return PhotoMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoMode>, I>>(_: I): PhotoMode {
    const message = createBasePhotoMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
